import { globalSearchAddress } from "@pages/AdminDashboard/adminRoutes";
import { AdminLink } from "@pages/AdminDashboard/ui/DataTable/cells";

// A User's email opens User Search with that email searched, the address the
// global search opens for it (XCUT-R35, SHELL-R17).
export const UserEmailLink = ({ email }: { email: string }) => {
  const userSearchAddress = globalSearchAddress(email);
  if (!userSearchAddress) return <>{email}</>;

  return <AdminLink to={userSearchAddress}>{email}</AdminLink>;
};

interface PatientIdentityProps {
  patient: { first_name: string; last_name: string; email: string };
}

// The patient's full name and email in the Redo and Ship context, the email
// opening that User (REDOUI-R9, SHIPUI-R8).
export const PatientIdentity = ({ patient }: PatientIdentityProps) => (
  <>
    {`${patient.first_name} ${patient.last_name}`.trim()} · <UserEmailLink email={patient.email} />
  </>
);
